import { ROUTES } from "../../../module/constants";

export const TEMPORARY_ABILITATIONS_URLS = {
  BASE_URL: ROUTES.TEMPORARY_ABILITATIONS,
  TEMPORARY_ABILITATIONS_LIST: `${ROUTES.TEMPORARY_ABILITATIONS}/temporaryAbilitationsList`,
  TEMPORARY_ABILITATIONS_REQUEST: `${ROUTES.TEMPORARY_ABILITATIONS}/temporaryAbilitationsRequest`,
  TEMPORARY_ABILITATIONS_EMERGENCY_LIST: `${ROUTES.TEMPORARY_ABILITATIONS}/temporaryAbilitationsEmergencyList`,
  TEMPORARY_ABILITATIONS_EMERGENCY_REQUEST: `${ROUTES.TEMPORARY_ABILITATIONS}/temporaryAbilitationsEmergencyRequest`,
};

export const STATE_IDENTIFIER = {
  TEMPORARY_ABILITATIONS: "temporaryAbilitations",
  EMERGENCY_TEMPORARY_ABILITATIONS: "emegencyTemporaryAbilitations",
  SELECTED_TEMPORARY_ABILITATION: "selectedTemporaryAbilitation",
  REQUEST_STATE: "requestState",
  FIELDS: "fields",
  FIELD_VALUE: "fieldValue",
  EXISTING_USER_ENTITLEMENTS: "existingUserEntitlements",
  SHOW_EMERGENCY: "showEmergency",
  SHOW_EMERGENCY_LOADER: "showEmergencyLoader",
  MISSING_ENTITLEMENTS: "missingEntitlements",
};

export const LIST_IDENTIFIER: string = "list";
export const LOADER_IDENTIFIER: string = "loader";
